import {gsap} from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
let tween_scroll_array = [];

/**
 * Initialisation des scrolls des images de contenu
 */
const init_scroll_scrub = (container) => {
    tween_scroll_array = [];
    $(container).find(".scrollScale img").each(function( index ) {
        let tween = gsap.to($( this ), {
            scrollTrigger: {
                trigger: $( this ),
                toggleActions: "restart none none none",
                scrub:true,
            },
            scale:1,
            ease:"none",
            // duration:1,
        });
        tween_scroll_array.push(tween);
    });

    $(container).find(".scrollText").each(function( index ) {
        var animateIn = gsap.timeline({

            // duration: 3,
            scrollTrigger: {
                trigger: $( this ),
                scrub: true,
                toggleActions: "restart none none none",
            }
        });
        animateIn.fromTo($( this ), {
                y:"+2px",
            },
            {
                y:"-2px",

            })
    });

    setTimeout(function (){ScrollTrigger.refresh(); }, 1000)

}


/**
 * Desinitialisation des scroll d'images de contenu
 */
const desinit_scroll_scrub = () => {
    $.each(tween_scroll_array, function( index, tween ) {
        tween.kill();
        tween = null;
    });
}

export {init_scroll_scrub, desinit_scroll_scrub}
